import React from 'react';

import money from '../../../images/money_ic.svg';

import { FOHImage } from '../../ingredients';

export const FOHMoneyIcon = () => (
  <FOHImage source={{ uri: money }} style={{ width: 21, height: 20 }} />
);
